import { BaseFlowBlockSchema, FlowBlockType, FlowRestResponseBodyFormat } from 'flow-schema';
import { z } from 'zod';

import { optionalEnum } from '../../../utils.js';
import { ApiInstanceFhirMethod } from '../../orchestrator/apiInstanceFhir.js';

export const MontageOnBaseBlockConfigSchema = z.object({
  apiInstanceId: z.uuid(),
  apiInstanceBaseUrl: z.string().url().optional(),
  method: z.enum(ApiInstanceFhirMethod),
  endpoint: z
    .string()
    .min(1)
    .transform((endpoint) => (endpoint.startsWith('/') ? endpoint : `/${endpoint}`)),
  headers: z
    .array(
      z.object({
        key: z.string().min(1, { message: 'Header key cannot be empty.' }),
        value: z.string().min(1, { message: 'Header value cannot be empty.' }),
      })
    )
    .refine(
      (headers) =>
        new Set(headers.map((header) => `${header.key}-${header.value}`)).size === headers.length,
      'Headers cannot have duplicates'
    )
    .optional(),
  responseBodyFormat: optionalEnum(
    FlowRestResponseBodyFormat,
    FlowRestResponseBodyFormat.AutoDetect
  ),
  body: z.string().optional(),
});

export type MontageOnBaseBlockConfig = z.infer<typeof MontageOnBaseBlockConfigSchema>;

export const MontageOnBaseBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.MontageOnBase),
  config: MontageOnBaseBlockConfigSchema,
});

export type MontageOnBaseBlock = z.infer<typeof MontageOnBaseBlockSchema>;
